const DEVICE_ID_STORAGE_KEY = 'leitour.device-id.v1';
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const getOrCreateDeviceId = (
  storage: Pick<Storage, 'getItem' | 'setItem'> = globalThis.localStorage,
  createUuid: () => string = () => globalThis.crypto.randomUUID()
): string => {
  const existing = storage.getItem(DEVICE_ID_STORAGE_KEY)?.trim();
  if (existing && UUID_PATTERN.test(existing)) return existing.toLowerCase();

  const created = createUuid().toLowerCase();
  if (!UUID_PATTERN.test(created)) throw new Error('Não foi possível criar uma identidade local válida para este dispositivo.');
  storage.setItem(DEVICE_ID_STORAGE_KEY, created);
  return created;
};

export { DEVICE_ID_STORAGE_KEY };
